import React from "react";
import disabled from "./Icons/disabled-possibilities.png";
import disabledIcon from "./Icons/disabled-people.png";

export const DisabledFacilities = props => {
  return (
    <div className="convenience-item d-flex align-items-center">
      <div className="convenience-symbol__container d-flex align-items-center">
        <img className="convenience-symbol" src={disabledIcon} alt="disabled icon" />
      </div>
      <div className="convenience-symbol__value d-flex align-items-center">
        <img src={disabled} alt="wheelchair blind death" />
      </div>
      <div className="convenience-symbol__description">Ułatwienia</div>
    </div>
  );
};
